import { catchResponseError } from 'packages/helpers/helpers';
import { parseUrl } from 'packages/helpers/urlUtils';

const portalService = {
    async getPortalFeatures(
        domain: string | undefined,
        accessToken: string,
        portalId: string,
    ): Promise<{ features: string[] }> {
        try {
            const response = await fetch(`${parseUrl(domain)}/v7/portal/portals/${portalId}/features/`, {
                method: 'GET',
                headers: getHeaders(accessToken),
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch portal features for ${portalId}: ${response.status}`);
            }

            return await response.json();
        } catch (e) {
            catchResponseError(e);

            throw e;
        }
    },
};

export default portalService;

function getHeaders(accessToken: string) {
    return {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
    };
}
